import * as React from "react";
const TagIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#4F4F4F"
      d="M13.47 2.529a2.48 2.48 0 0 0-2.158-.7l-3.359.53a2.485 2.485 0 0 0-1.378.7l-4.49 4.49a2 2 0 0 0 0 2.828l3.536 3.535a2 2 0 0 0 2.828 0l4.49-4.489c.374-.373.62-.856.7-1.378l.53-3.359a2.475 2.475 0 0 0-.7-2.157Zm-.286 2-.53 3.359a1.488 1.488 0 0 1-.422.827l-4.49 4.489a1.024 1.024 0 0 1-1.414 0L2.793 9.671a1 1 0 0 1 0-1.414l4.49-4.49c.223-.225.513-.373.826-.421l3.359-.531a1.5 1.5 0 0 1 1.716 1.716v-.002Z"
    />
    <path
      fill="#4F4F4F"
      d="M8.802 5.074a1.5 1.5 0 1 0 2.122 0 1.536 1.536 0 0 0-2.122 0Zm1.415 1.414a.5.5 0 1 1-.695-.72.5.5 0 0 1 .695.72Z"
    />
  </svg>
);
export default TagIcon;
